import {
  DISCORD_URL,
  INSTAGRAM_URL,
  TWITCH_URL,
  YOUTUBE_ASMR_URL,
  YOUTUBE_CERAMICA_URL,
} from './social';

export const SITE_URL = 'https://eugenial.com.ar';
export const SITE_NAME = 'EuGe_NiAL';

export const DEFAULT_TITLE = 'EuGe_NiAL · Streamer ASMR · Argentina';
export const DEFAULT_DESCRIPTION =
  'Streamer ASMR argentina. Directos de calma en Twitch de lunes a viernes, comunidad Eugenialitos, cerámica, oráculos y subastas. Seguime en Twitch e Instagram.';

export const DEFAULT_KEYWORDS =
  'EuGe_NiAL, Eugenial, Eugenia, ASMR, streamer, Argentina, Twitch, Eugenialitos, cerámica, oráculos, subastas, relajación';

/** Imagen landscape ~2:1 — mejor preview en WhatsApp, Discord y Twitter */
export const OG_IMAGE_PATH = '/images/twitch-back.png';
export const OG_IMAGE_WIDTH = 652;
export const OG_IMAGE_HEIGHT = 383;
export const OG_IMAGE_ALT = 'EuGe_NiAL — Streamer ASMR en Twitch';

export const TWITTER_HANDLE = '@euge_nial_';

export const SOCIAL_PROFILES = [
  TWITCH_URL,
  INSTAGRAM_URL,
  DISCORD_URL,
  YOUTUBE_ASMR_URL,
  YOUTUBE_CERAMICA_URL,
] as const;

export function absoluteUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

export function buildTitle(page?: string): string {
  return page ? `${page} · ${SITE_NAME}` : DEFAULT_TITLE;
}

export function truncateDescription(text: string, max = 160): string {
  const clean = text.replace(/\s+/g, ' ').trim();
  if (clean.length <= max) return clean;
  return `${clean.slice(0, max - 1).trim()}…`;
}
